import styles from "./index.module.less";

import {
  ButtonField,
  Modal,
  ModalFooter,
  ModalBody,
  ButtonGroup,
  ButtonGroupItem,
  ModalHeader,
  Iconsvg,
} from "@wk/components-react16";

const ModalConfirm = ({
  title,
  isOpen,
  onClose,
  onConfirm,
  children,
  isConfirmLoading = false,
  okText = "确认",
  height = "284px",
  cancelText = "取消",
  onCancel = onClose,
  isFooter = true,
}) => {
  return (
    <div className={styles["ModalConfirm"]}>
      <Modal
        width={"441px"}
        height={height}
        isOpen={isOpen}
        srLabelledBy={"modal-id-001"}
        srDescribedBy={"modal-id-002"}
        onUserRequest={(event) => onClose()}
      >
        <ModalHeader titleId={"modal-id-001"} onUserRequest={() => onClose()}>
          {title}
        </ModalHeader>
        <ModalBody descriptionId="modal-id-002">{children}</ModalBody>
        {isFooter && (
          <ModalFooter>
            <ButtonGroup mode="static">
              <ButtonGroupItem slot="buttonGroupItem">
                <ButtonField mode={"ghost"}>
                  <button
                    type="button"
                    id="cancel"
                    onClick={() => onCancel()}
                    disabled={isConfirmLoading}
                  >
                    {cancelText}
                  </button>
                </ButtonField>
              </ButtonGroupItem>
              <ButtonGroupItem slot="buttonGroupItem">
                <ButtonField>
                  <button
                    type="button"
                    id="save"
                    onClick={() => onConfirm()}
                    disabled={isConfirmLoading}
                  >
                    {okText}
                    {isConfirmLoading && (
                      <Iconsvg name="spinner-alt" isSpin></Iconsvg>
                    )}
                  </button>
                </ButtonField>
              </ButtonGroupItem>
            </ButtonGroup>
          </ModalFooter>
        )}
      </Modal>
    </div>
  );
};
export default ModalConfirm;
